"use client";

import Link from "next/link";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getCookieConsent, saveCookieConsent } from "@/libs/cookie-consent";

export function CookieConsentBanner() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const currentConsent = getCookieConsent();
    setIsOpen(!currentConsent);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <Box
      role="dialog"
      aria-label="Consentimento de cookies"
      sx={{
        position: "fixed",
        left: { xs: 12, sm: 20, md: 24 },
        right: { xs: 12, sm: 20, md: 24 },
        bottom: { xs: 12, sm: 20, md: 24 },
        zIndex: 1400,
        border: "1px solid hsl(var(--border))",
        borderRadius: 2,
        backgroundColor: "background.paper",
        boxShadow: "0 12px 36px hsl(var(--foreground) / 0.18)",
        p: { xs: 2, sm: 2.5, md: 3 },
      }}
    >
      <Typography variant="subtitle1" fontWeight={700}>
        Cookies e privacidade
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
        Usamos cookies essenciais para funcionamento do site e opcionais para
        métricas e suporte (chat). Você pode aceitar todos ou rejeitar os
        opcionais.
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Saiba mais em{" "}
        <Link href="/privacidade" style={{ textDecoration: "underline" }}>
          Política de Privacidade
        </Link>{" "}
        e{" "}
        <Link href="/termos" style={{ textDecoration: "underline" }}>
          Termos de Uso
        </Link>
        .
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.25}
        sx={{ mt: 2 }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            saveCookieConsent({ analytics: false, support: false });
            setIsOpen(false);
          }}
        >
          Rejeitar opcionais
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            saveCookieConsent({ analytics: true, support: true });
            setIsOpen(false);
          }}
        >
          Aceitar todos
        </Button>
      </Stack>
    </Box>
  );
}
